import { NaturalDimensions } from "types";

// Size of the part of the image left visible after zooming to the center crop
export const getCenterCropDimensions = (
  dimensions: NaturalDimensions,
  centerCropSize: number,
): NaturalDimensions => {
  const { naturalWidth, naturalHeight } = dimensions;
  if (centerCropSize <= 0 || naturalWidth <= 0 || naturalHeight <= 0) {
    return dimensions;
  }
  return {
    naturalWidth: Math.min(naturalWidth, centerCropSize),
    naturalHeight: Math.min(naturalHeight, centerCropSize),
  };
};
